import config from '../_config/config';
import { authHeader } from '../_helpers';
//console.log( config );

export const productService = {
    save,
    getOne,
    getAll,
    uploadImages,
    logout,
};

function save( id, articlenumber, attributes ) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(), //{ 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, articlenumber, attributes })
        };


    return fetch(`${config.apiUrl}/products/save/`, requestOptions)
        .then(handleResponse)
        .then(data => {
          if( data.success ) {
            //console.log( data );
            return data;
          }
        });

}

function uploadImages(files, articlenumber){
  
          let filesData = new FormData();
          for(var i=0;i< files.length ;i++){
          	filesData.append("uploadData[]", files[i] )
          	filesData.append('articlenumber', articlenumber)
          }
          
    const requestOptions = {
        method: 'POST',
        headers: authHeader(), //{ 'Content-Type': 'application/json' },
        body: filesData
        };
        
/*
  console.log('diese files: ')
  console.log(files)
*/
        
   return fetch(`${config.apiUrl}/products/upload-images/`, requestOptions)
        .then(handleResponse)
        .then(res => {
          if( res.success ) {
            return res;
          }
        });
        
        
}

function getOne() {
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/products/`, requestOptions)
        .then(handleResponse)
        .then(res => {
                        
            localStorage.setItem('products', JSON.stringify( res.products ));
            
            return res.products
            })


}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            console.log( response )
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}